import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { BOOKING_URL, PRICE, offerItems } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full scroll-mt-4 bg-ink-850" data-id="element-98" data-mp="306zsj76lrhu2">
      <div className="mx-auto max-w-2xl px-5 py-16 md:py-24" data-id="element-99" data-mp="356m5dfiiqw2c">
        <div className="rounded-3xl border-2 border-brand-green bg-ink-card p-6 shadow-panel md:p-10" data-id="element-100" data-mp="353zp8rhkb88i">
          <h2 id="oferta-title" className="text-center font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-101" data-mp="3f4jsu0sk0otw">
            Todo lo que incluye el pack
          </h2>
          <p className="mt-2 text-center text-sm text-subtle" data-id="element-102" data-mp="3nwlo7knrnexb">
            Pack de asesoramiento para padres de futbolistas
          </p>

          <ul className="mt-8 space-y-3.5" data-id="element-103" data-mp="3sx9iqgb7edwa">
            {offerItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-104" data-mp="1qosuzwvxc0u">
                <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-green text-black" data-id="element-105" data-mp="1kl89ywefpfas">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-106" data-mp="1bkij87416f3x" />
                </span>
                <span className="text-[16px] leading-snug text-white" data-id="element-107" data-mp="16lp46a93ig1n">{item}</span>
              </li>)}
          </ul>

          <div className="mt-8 rounded-2xl bg-ink-950 px-6 py-7 text-center" data-id="element-108" data-mp="23awnrcq5mf2x">
            <p className="font-display text-5xl font-black text-white md:text-6xl" data-id="element-109" data-mp="1z9um6p8rlqxs">{PRICE}</p>
            <p className="mt-2 text-sm text-body" data-id="element-110" data-mp="1ujeb3bsf2hel">Videollamada · +200 páginas de material en PDF</p>
          </div>

          <div className="mt-7" data-id="element-111" data-mp="1plcrmpr2wg2l">
            <CtaButton size="xl" fullWidth href={BOOKING_URL} data-id="element-112" data-mp="1pk1lija5uw8b" />
          </div>
          <p className="mt-4 flex items-center justify-center gap-2 text-sm text-subtle" data-id="element-113" data-mp="2n10aztwontk8">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="2i8yw0084roqi" />
            Pago seguro mediante Mercado Pago.
          </p>
        </div>
      </div>
    </section>;
}